import * as React from 'react'

import { FieldTrigger } from '~/client/src/shared/components/FieldTrigger'
import LocationIcon from '~/client/src/shared/components/LocationIcon/LocationIcon'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { iconLabel } from './iconCatalog'

type IProps = React.ComponentPropsWithoutRef<typeof FieldTrigger> & {
  value: string
}

const IconPickerTrigger = React.forwardRef<HTMLButtonElement, IProps>(
  ({ value, ...props }, ref) => (
    <FieldTrigger
      aria-label={`${Localization.translator.icon}: ${iconLabel(value)}`}
      {...props}
      ref={ref}
    >
      <LocationIcon iconName={value} className="tw:block" />
    </FieldTrigger>
  ),
)
IconPickerTrigger.displayName = 'IconPickerTrigger'

export default IconPickerTrigger
